import { cva } from 'class-variance-authority'
export const tabsListStyles = cva(
  `
    inline-flex
    items-center
    justify-center
    p-1
    text-neutral-600
  `,
  {
    variants: {
      variant: {
        default: `
          rounded-lg
          bg-neutral-50
        `,
        outline: `
          rounded-none
        `,
      },
      fullWidth: {
        true: 'flex w-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      fullWidth: false,
    },
  }
)
export const tabsTriggerStyles = cva(
  `
    inline-flex
    items-center
    justify-center
    whitespace-nowrap

    text-sm
    text-neutral-600
    font-medium
    ring-offset-background
    transition-all
    focus-visible:outline-none
    focus-visible:ring-2
    focus-visible:ring-ring
    focus-visible:ring-offset-2
    hover:cursor-pointer
    hover:bg-neutral-25
    disabled:pointer-events-none
    disabled:opacity-50
  `,
  {
    variants: {
      variant: {
        default: `
            rounded-md
            data-[state=active]:bg-neutral-0
            data-[state=active]:text-neutral-600
            h-[32px]
            px-2
            py-1
          `,
        outline: `
          data-[state=active]:border-b-2
          data-[state=active]:border-neutral-900
          border-b-2
          border-neutral-0
          text-neutral-900
          px-4
          py-3
          inline-block`,
      },
      fullWidth: {
        true: 'flex-1',
      },
    },
    defaultVariants: {
      variant: 'default',
      fullWidth: false,
    },
  }
)

export const tabsContentStyles = cva(
  `
  mt-2
  ring-offset-background
  focus-visible:outline-none
  focus-visible:ring-2
  focus-visible:ring-ring
  focus-visible:ring-offset-2
  `,
  {
    variants: {
      variant: {
        default: '',
        outline: '',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)
